import actionConsts from 'constants/actions';

const updateTimer = (payload) => ({
	type: actionConsts.get('SET_TIMER_STATE'),
	payload
})

export {
	updateTimer
}